import { DomainCitizenshipType } from "@porchpass/api-client";
import type { CitizenshipFormData } from "@porchpass/ui";

const CITIZENSHIP_TO_DLA: Record<string, string> = {
  [DomainCitizenshipType.Citizen]: "CITIZEN",
  [DomainCitizenshipType.PermanentResident]: "PERMANENT_RESIDENT",
  [DomainCitizenshipType.NonPermanentResident]: "NON_PERMANENT_RESIDENT",
};

const CITIZENSHIP_FROM_DLA: Record<string, DomainCitizenshipType> = {
  CITIZEN: DomainCitizenshipType.Citizen,
  PERMANENT_RESIDENT: DomainCitizenshipType.PermanentResident,
  NON_PERMANENT_RESIDENT: DomainCitizenshipType.NonPermanentResident,
};

export function toCitizenshipFormData(
  citizenshipType?: string,
): CitizenshipFormData {
  return {
    citizenship: citizenshipType
      ? (CITIZENSHIP_FROM_DLA[citizenshipType] ?? "")
      : "",
  };
}

export function fromCitizenshipFormData(
  data: CitizenshipFormData,
): { citizenship_type: string } | undefined {
  if (!data.citizenship) return undefined;
  const citizenship_type = CITIZENSHIP_TO_DLA[data.citizenship];
  return citizenship_type ? { citizenship_type } : undefined;
}
